import { flatten } from 'lodash';
import useFetchLayoutServiceModel from '../../../core/apiHooks/useFetchLayoutServiceModel';
import { selectAllTrims } from '../../../core/apis/layoutServiceApi';
/**
 * Get colors data from Layout Service API
 *
 */
const useFetchColors = (sitecoreId, modelYear) => {
    const { trims: trimEntity, isFetching, hasError, isSuccess, isUninitialized, } = useFetchLayoutServiceModel(sitecoreId, modelYear);
    const allTrims = selectAllTrims(trimEntity);
    const colorsByTrim = flatten(allTrims.map(trim => {
        var _a;
        const trimKey = trim === null || trim === void 0 ? void 0 : trim.trimKey;
        return (_a = trim === null || trim === void 0 ? void 0 : trim.transmissions) === null || _a === void 0 ? void 0 : _a.map(t => {
            var _a;
            return ({
                trimKey,
                transmissionKey: t === null || t === void 0 ? void 0 : t.transmissionKey,
                defaultExteriorColorKey: t === null || t === void 0 ? void 0 : t.exteriorColorKey,
                defaultInteriorColorKey: t === null || t === void 0 ? void 0 : t.interiorColorKey,
                exteriorColors: (_a = t === null || t === void 0 ? void 0 : t.exteriorColors) !== null && _a !== void 0 ? _a : [],
            });
        });
    }));
    return { colors: colorsByTrim, isFetching, hasError, isSuccess, isUninitialized };
};
export default useFetchColors;
